import { useContext } from "react";
import { LinearProgress, Box, Tooltip } from "@mui/material";
import { ProjectContext } from "../../shared/context/ProjectContext";

const LinearProgressWithLabel = () => {
  const {
    state: { progress = {} },
  } = useContext(ProjectContext);

  if (!progress) {
    return null;
  }

  return (
    <Tooltip
      title={`Current annotation progress: ${progress.dataset_items_saved} / ${progress.dataset_size}}`}
      placement="top"
    >
      <Box sx={{ width: "100%", cursor: "help" }}>
        <LinearProgress
          variant="determinate"
          value={progress.value}
          sx={{ height: "6px" }}
        />
      </Box>
    </Tooltip>
  );
};

export default LinearProgressWithLabel;
